import { cn } from "@/lib/utils";

const STATUS = {
  vigente: "bg-emerald-100 text-emerald-800 dark:bg-emerald-950 dark:text-emerald-300",
  pagado: "bg-emerald-100 text-emerald-800 dark:bg-emerald-950 dark:text-emerald-300",
  cobrada: "bg-emerald-100 text-emerald-800 dark:bg-emerald-950 dark:text-emerald-300",
  disponible: "bg-emerald-100 text-emerald-800 dark:bg-emerald-950 dark:text-emerald-300",
  rentado: "bg-sky-100 text-sky-800 dark:bg-sky-950 dark:text-sky-300",
  parcial: "bg-sky-100 text-sky-800 dark:bg-sky-950 dark:text-sky-300",
  en_proceso: "bg-sky-100 text-sky-800 dark:bg-sky-950 dark:text-sky-300",
  pendiente: "bg-amber-100 text-amber-800 dark:bg-amber-950 dark:text-amber-300",
  generada: "bg-amber-100 text-amber-800 dark:bg-amber-950 dark:text-amber-300",
  pendiente_cobro: "bg-amber-100 text-amber-800 dark:bg-amber-950 dark:text-amber-300",
  mantenimiento: "bg-amber-100 text-amber-800 dark:bg-amber-950 dark:text-amber-300",
  vencido: "bg-red-100 text-red-800 dark:bg-red-950 dark:text-red-300",
  en_resguardo: "bg-amber-100 text-amber-800 dark:bg-amber-950 dark:text-amber-300",
  parcial_dep: "bg-sky-100 text-sky-800 dark:bg-sky-950 dark:text-sky-300",
  aplicado: "bg-sky-100 text-sky-800 dark:bg-sky-950 dark:text-sky-300",
  devuelto: "bg-emerald-100 text-emerald-800 dark:bg-emerald-950 dark:text-emerald-300",
  cancelado: "bg-red-100 text-red-700 dark:bg-red-950 dark:text-red-400",
  cancelada: "bg-red-100 text-red-700 dark:bg-red-950 dark:text-red-400",
  baja: "bg-neutral-200 text-neutral-700 dark:bg-neutral-800 dark:text-neutral-300",
  no_disponible: "bg-neutral-200 text-neutral-700 dark:bg-neutral-800 dark:text-neutral-300",
};

const LABELS = {
  en_proceso: "En proceso",
  no_disponible: "No disponible",
  pendiente_cobro: "Pendiente cobro",
  en_resguardo: "En resguardo",
};

export function StatusBadge({ estado }) {
  const cls = STATUS[estado] || "bg-neutral-200 text-neutral-700";
  const label = LABELS[estado] || (estado ? estado.charAt(0).toUpperCase() + estado.slice(1) : "—");
  return (
    <span
      data-testid={`status-${estado}`}
      className={cn("inline-flex items-center rounded-sm px-2 py-0.5 text-xs font-semibold uppercase tracking-wide", cls)}
    >
      {label}
    </span>
  );
}

export function StatCard({ label, value, sub, icon: Icon, tone = "default", testId }) {
  const tones = {
    default: "text-foreground",
    primary: "text-primary",
    accent: "text-[hsl(var(--accent))]",
    danger: "text-red-600 dark:text-red-400",
    warn: "text-amber-600 dark:text-amber-400",
  };
  return (
    <div data-testid={testId} className="bg-card border border-border rounded-sm p-4 flex flex-col gap-2 h-full">
      <div className="flex items-center justify-between">
        <span className="text-xs font-medium uppercase tracking-wide text-muted-foreground">{label}</span>
        {Icon && <Icon size={18} weight="duotone" className="text-muted-foreground" />}
      </div>
      <div className={cn("text-2xl font-display font-bold tabular-nums", tones[tone])}>{value}</div>
      {sub && <div className="text-xs text-muted-foreground">{sub}</div>}
    </div>
  );
}

export function PageHeader({ title, subtitle, actions }) {
  return (
    <div className="flex flex-wrap items-end justify-between gap-4 mb-6">
      <div>
        <h1 className="text-3xl font-display font-bold tracking-tight">{title}</h1>
        {subtitle && <p className="text-sm text-muted-foreground mt-1">{subtitle}</p>}
      </div>
      {actions && <div className="flex gap-2">{actions}</div>}
    </div>
  );
}

export function EmptyState({ title, hint, action }) {
  return (
    <div className="border border-dashed border-border rounded-sm p-10 text-center">
      <p className="font-medium">{title}</p>
      {hint && <p className="text-sm text-muted-foreground mt-1">{hint}</p>}
      {action && <div className="mt-4 flex justify-center">{action}</div>}
    </div>
  );
}
